/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection06FoiChanged, m11ReportSection06ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection06Foi, selectM11ReportSection06Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";
import { Button, Dropdown, Table } from "semantic-ui-react";
import { TextField } from "@mui/material";

const saveTrialInterventionChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section06State, setAlertModalState, setStartingSection06State) => {

    let changesStates = {
        section06State: section06State
    };
    let response = await saveM11Changes(apiToken, 21, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection06Resource) {
            dispatch(m11ReportSection06ResourceChanged(response.m11ReportSection06Resource));
        }
        setStartingSection06State(JSON.parse(JSON.stringify(section06State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const TableCodeEntry = ({ elementName, fieldLabel, startingValue, index, setTableDataState, allowedValues }) => {
    if (!allowedValues) {
        return <></>
    }
    return <Table.Cell style={{ paddingRight: "0px", paddingTop: "8px", paddingBottom: "8px", verticalAlign: "top" }}>
        <Dropdown
            name={elementName}
            placeholder={fieldLabel}
            search={true}
            closeOnChange selection clearable selectOnBlur={false} autoComplete='off'
            style={{ minWidth: "100px", width: "100%" }}
            options={allowedValues.map((code, codeIndex) => { return { "key": codeIndex, "value": code, "text": code } })}
            value={startingValue}
            onChange={(e, data) => {
                setTableDataState(prevState => {
                    let newArray = JSON.parse(JSON.stringify(prevState.tabledata));
                    newArray[index][elementName] = data.value;
                    return { ...prevState, "tabledata": newArray };
                });
            }}
        />
    </Table.Cell>
};

const TableStringEntry = ({ startingValue, fieldLabel, index, setTableDataState, elementName }) => {
    return <Table.Cell style={{ paddingRight: "0px", paddingTop: "8px", paddingBottom: "8px", verticalAlign: "top" }}>
        <TextField style={{ width: "100%" }} multiline className="inputField" type='text'
            label={fieldLabel} size="small" variant='outlined'
            value={startingValue || ''}
            onChange={(e) => {
                setTableDataState(prevState => {
                    let newArray = JSON.parse(JSON.stringify(prevState.tabledata));
                    newArray[index][elementName] = e.target.value;
                    return { ...prevState, "tabledata": newArray };
                });
            }} />
    </Table.Cell>
}

const TableEntry = ({ tabledata, setTableDataState }) => {

    return <>
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell style={{ width: "8%" }}>Arm Name</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Arm Type</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Intervention Name</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Intervention Type</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Pharmaceutical Dose Form</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Dosage Strength(s)</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Dosage Level(s)</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Route of Administration</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Regimen/Treatment Period/Vaccination Regimen</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Use</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>IMP/NIMP</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "8%" }}>Sourcing</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {tabledata?.map((tablerow, index) => {
                    return <Table.Row key={index}>
                        <TableStringEntry startingValue={tablerow.armName}
                            fieldLabel='Arm Name'
                            elementName="armName"
                            index={index} setTableDataState={setTableDataState} />
                        <TableCodeEntry startingValue={tablerow.armType}
                            fieldLabel='Arm Type'
                            elementName="armType"
                            allowedValues={["Active Comparator Arm", "Control Arm", "Experimental Arm",
                                "No Intervention Arm", "Placebo Comparator Arm", "Sham Comparator Arm"]}
                            index={index} setTableDataState={setTableDataState} />
                        <TableStringEntry startingValue={tablerow.interventionName}
                            fieldLabel='Intervention Name'
                            elementName="interventionName"
                            index={index} setTableDataState={setTableDataState} />
                        <TableCodeEntry startingValue={tablerow.interventionType}
                            fieldLabel='Intervention Type'
                            elementName="interventionType"
                            allowedValues={["Drug", "Medical Device", "Biologic", "Vaccine",
                                "Non-Surgical Procedure", "Surgery", "Radiation", "Behavioral",
                                "Genetic", "Dietary Supplement", "Combination Product", "Diagnostic"]}
                            index={index} setTableDataState={setTableDataState} />
                        <TableStringEntry startingValue={tablerow.doseForm}
                            fieldLabel='Dose Form'
                            elementName="doseForm"
                            index={index} setTableDataState={setTableDataState} />
                        <TableStringEntry startingValue={tablerow.dosageStrength}
                            fieldLabel='Dosage Strength'
                            elementName="dosageStrength"
                            index={index} setTableDataState={setTableDataState} />
                        <TableStringEntry startingValue={tablerow.dosageLevel}
                            fieldLabel='Dosage Level'
                            elementName="dosageLevel"
                            index={index} setTableDataState={setTableDataState} />
                        <TableStringEntry startingValue={tablerow.routeOfAdministration}
                            fieldLabel='Route of Administration'
                            elementName="routeOfAdministration"
                            index={index} setTableDataState={setTableDataState} />
                        <TableStringEntry startingValue={tablerow.regimen}
                            fieldLabel='Regimen/Treatment Period'
                            elementName="regimen"
                            index={index} setTableDataState={setTableDataState} />
                        <TableCodeEntry startingValue={tablerow.use}
                            fieldLabel='Use'
                            elementName="use"
                            allowedValues={["Experimental Intervention", "Placebo", "Rescue Medicine", "Background Treatment",
                                "Challenge Agent", "Diagnostic", "Additional Required Treatment"]}
                            index={index} setTableDataState={setTableDataState} />
                        <TableCodeEntry startingValue={tablerow.impOrNimp}
                            fieldLabel='IMP or NIMP'
                            elementName="impOrNimp"
                            allowedValues={["IMP", "NIMP"]}
                            index={index} setTableDataState={setTableDataState} />
                        <TableCodeEntry startingValue={tablerow.sourcing}
                            fieldLabel='Sourcing'
                            elementName="sourcing"
                            allowedValues={["Centrally Sourced", "Locally Sourced", "Centrally Sourced and Locally Sourced"]}
                            index={index} setTableDataState={setTableDataState} />
                    </Table.Row>;
                })
                }
            </Table.Body>
        </Table>
        <span>
            <Button className="formButton" style={{ color: "#000000" }}
                content='+Add Row'
                onClick={() => {
                    setTableDataState(prevState => {
                        let newArray = [{}];
                        if (prevState.tabledata) {
                            newArray = prevState.tabledata.concat([{}]);
                        }
                        return { ...prevState, "tabledata": newArray };
                    });
                }} />
        </span>
    </>
}

const M11Step021TrialInterventionPart1 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection06Foi = useSelector(selectM11ReportSection06Foi);
    const m11ReportSection06Resource = useSelector(selectM11ReportSection06Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section06State, setSection06State] = useState({
        "section6Status": "empty", "section6Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Trial interventions are all pre-specified investigational and noninvestigational medicinal products, medical devices or other interventions intended for the participants during the trial. The investigational trial intervention is the product used in the trial as part of trial objectives. Description of the investigational trial intervention is provided in Section 6.1 Description of Trial Intervention. Other trial interventions that are not part of trial objectives or do not have an investigational role in this trial are described in Section 6.9 Description of Noninvestigational Trial Interventions. Any regional requirements should be noted in the appropriate subsections. Provide an overview of investigational and noninvestigational trial interventions. Designate the trial intervention as IMP or NIMP/AxMP based on trial design and regional requirements. Consider an optional table with 12 columns (Arm Name, Arm Type, Intervention Name, Intervention Type, Pharmaceutical Dose Form, Dosage Strength(s), Dosage Level(s), Route of Administration, Regimen/Treatment Period/Vaccination Regimen, Use, IMP/NIMP, Sourcing).]</div>'
    });
    const [startingSection06State, setStartingSection06State] = useState({
        "section6Status": "empty", "section6Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Trial interventions are all pre-specified investigational and noninvestigational medicinal products, medical devices or other interventions intended for the participants during the trial. The investigational trial intervention is the product used in the trial as part of trial objectives. Description of the investigational trial intervention is provided in Section 6.1 Description of Trial Intervention. Other trial interventions that are not part of trial objectives or do not have an investigational role in this trial are described in Section 6.9 Description of Noninvestigational Trial Interventions. Any regional requirements should be noted in the appropriate subsections. Provide an overview of investigational and noninvestigational trial interventions. Designate the trial intervention as IMP or NIMP/AxMP based on trial design and regional requirements. Consider an optional table with 12 columns (Arm Name, Arm Type, Intervention Name, Intervention Type, Pharmaceutical Dose Form, Dosage Strength(s), Dosage Level(s), Route of Administration, Regimen/Treatment Period/Vaccination Regimen, Use, IMP/NIMP, Sourcing).]</div>'
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
    const [tableDataState, setTableDataState] = useState({ tabledata: [{}] });
    const [remount, setRemount] = useState(1);

    const replaceWithTable = () => {
        if (tableDataState.tabledata.length > 0 && Object.keys(tableDataState.tabledata[0]).length > 0) {
            let section6Xhtml = '<div xmlns="http://www.w3.org/1999/xhtml">';
            section6Xhtml += "<table><tbody><tr><td>Arm Name</td><td>Arm Type</td><td>Intervention Name</td><td>Intervention Type</td><td>Pharmaceutical Dose Form</td><td>Dosage Strength(s)</td><td>Dosage Level(s)</td><td>Route of Administration</td><td>Regimen/Treatment Period/Vaccination Regimen</td><td>Use</td><td>IMP/NIMP</td><td>Sourcing</td></tr>";
            for (const row of tableDataState.tabledata) {
                section6Xhtml += "<tr><td>" + row.armName + "</td><td>" + row.armType + "</td><td>" +
                    row.interventionName + "</td><td>" + row.interventionType + "</td><td>" + row.doseForm +
                    "</td><td>" + row.dosageStrength + "</td><td>" + row.dosageLevel + "</td><td>" +
                    row.routeOfAdministration + "</td><td>" + row.regimen + "</td><td>" + row.use + "</td><td>" +
                    row.impOrNimp + "</td><td>" + row.sourcing + "</td></tr>";
            }
            section6Xhtml += "</tbody></table><p>IMP=Investigational Medicinal Product; NIMP=NonInvestigational/Auxiliary Medicinal Product.</p></div>";
            setSection06State(prevState => {
                return {
                    ...prevState,
                    "section6Status": "additional",
                    "section6Xhtml": section6Xhtml
                }
            })
            setRemount(prevState => prevState + 1);
        } else {
            alert("Enter data in the table first.");
        }
    };

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section06State, startingSection06State)),
        async saveAllChanges() {
            await saveTrialInterventionChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section06State, setAlertModalState, setStartingSection06State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section6Status": "empty", "section6Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Trial interventions are all pre-specified investigational and noninvestigational medicinal products, medical devices or other interventions intended for the participants during the trial. The investigational trial intervention is the product used in the trial as part of trial objectives. Description of the investigational trial intervention is provided in Section 6.1 Description of Trial Intervention. Other trial interventions that are not part of trial objectives or do not have an investigational role in this trial are described in Section 6.9 Description of Noninvestigational Trial Interventions. Any regional requirements should be noted in the appropriate subsections. Provide an overview of investigational and noninvestigational trial interventions. Designate the trial intervention as IMP or NIMP/AxMP based on trial design and regional requirements. Consider an optional table with 12 columns (Arm Name, Arm Type, Intervention Name, Intervention Type, Pharmaceutical Dose Form, Dosage Strength(s), Dosage Level(s), Route of Administration, Regimen/Treatment Period/Vaccination Regimen, Use, IMP/NIMP, Sourcing).]</div>',
                "loaded": true
            };
            setSection06State(startingData);
            setStartingSection06State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[6]?.entry?.length) {
                let m11ReportSection006Foi = getIdFromReference(m11ReportContainerResource.section[6].entry[0]);
                if (m11ReportSection006Foi && !isNaN(m11ReportSection006Foi) && m11ReportSection006Foi !== m11ReportSection06Foi) {
                    dispatch(m11ReportSection06FoiChanged(m11ReportSection006Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection06Foi && !isNaN(m11ReportSection06Foi)) {
            loadResource(m11ReportSection06Foi, "M11ReportSection06", apiToken, dispatch);
        }
    }, [m11ReportSection06Foi]);

    useEffect(() => {
        if (m11ReportSection06Resource && Object.keys(m11ReportSection06Resource).length > 0) {
            let startingData = {
                "section6Status": "empty", "section6Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Trial interventions are all pre-specified investigational and noninvestigational medicinal products, medical devices or other interventions intended for the participants during the trial. The investigational trial intervention is the product used in the trial as part of trial objectives. Description of the investigational trial intervention is provided in Section 6.1 Description of Trial Intervention. Other trial interventions that are not part of trial objectives or do not have an investigational role in this trial are described in Section 6.9 Description of Noninvestigational Trial Interventions. Any regional requirements should be noted in the appropriate subsections. Provide an overview of investigational and noninvestigational trial interventions. Designate the trial intervention as IMP or NIMP/AxMP based on trial design and regional requirements. Consider an optional table with 12 columns (Arm Name, Arm Type, Intervention Name, Intervention Type, Pharmaceutical Dose Form, Dosage Strength(s), Dosage Level(s), Route of Administration, Regimen/Treatment Period/Vaccination Regimen, Use, IMP/NIMP, Sourcing).]</div>',
                "loaded": true
            };
            if (m11ReportSection06Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection06Resource.section[0].text?.div &&
                    m11ReportSection06Resource.section[0].text.status !== "empty") {
                    startingData.section6Status = m11ReportSection06Resource.section[0].text.status;
                    startingData.section6Xhtml = m11ReportSection06Resource.section[0].text.div;
                }
                setSection06State(startingData);
                setStartingSection06State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection06Resource]);

    return <div>
        <h3>Add first part of Section 6 Trial Intervention and Concomitant Therapy</h3>
        {!(m11ReportSection06Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 21 (Add first part of Section 6 Trial Intervention and Concomitant Therapy) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>     {section06State.loaded && <>
                <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6 TRIAL INTERVENTION AND CONCOMITANT THERAPY.</h4>
                <p>Consider the optional table.</p>
                <div style={{ marginLeft: "24px" }} >
                    <p>Enter data in each cell of the table.</p>
                    <p>Add rows as needed.</p>
                    <p>Click to replace the summary below with the table.</p>
                </div>
                <TableEntry tabledata={tableDataState.tabledata} setTableDataState={setTableDataState} />
                <Button className="formButton navigationButton"
                    style={{
                        color: "#000000",
                        fontSize: "20px",
                        width: "100%",
                        margin: "0px"
                    }}
                    content="Replace Section 6 opening summary with Table."
                    onClick={() => {
                        replaceWithTable();
                    }}
                />
                {remount && <TextDivEntry elementName="section6Xhtml" key={remount}
                    startingValue={section06State.section6Xhtml}
                    setResourceState={setSection06State} />}
            </>}</>
        }
    </div >
});

const M11Step021TrialInterventionPart1HelperText = <div>
    <h3>Add first part of Section 6 Trial Intervention and Concomitant Therapy</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 6 TRIAL INTERVENTION AND CONCOMITANT THERAPY.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Trial interventions are all pre-specified investigational and noninvestigational medicinal products, medical devices or other interventions intended for the participants during the trial. The investigational trial intervention is the product(s) used in the trial as part of trial objectives, including control(s) (e.g., active comparator, placebo). Description of the investigational trial intervention is provided in Section 6.1 Description of Investigational Trial Intervention. Other trial interventions that are not part of trial objectives or do not have an investigational role in this trial are described in Section 6.9 Description of Noninvestigational Trial Intervention.</p>
            <p>Any regional requirements should be noted in the appropriate subsections.</p>
            <p>Provide an overview of investigational and noninvestigational trial interventions. Designate the trial intervention as IMP or NIMP/AxMP based on trial design and regional requirements.</p>
        </div>
        <p>Consider the optional table.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Enter data in each cell of the table.</p>
            <p>Add rows as needed.</p>
            <p>Delete the table if not used.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step021TrialInterventionPart1ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 21, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 21 (Add first part of Section 6 Trial Intervention and Concomitant Therapy) {validationCheckState.step21numberOfChecks} issues checked. {validationCheckState.step21numberPassed} passed. {validationCheckState.step21numberFailed} failed.</h4>
        <p>Section 6 heading is 'TRIAL INTERVENTION AND CONCOMITANT THERAPY': {validationCheckState.resultCheckSection6Heading}</p>
        <p>Section 6 TRIAL INTERVENTION AND CONCOMITANT THERAPY has content: {validationCheckState.resultCheckSection6Content}</p>
    </div>}  </div>
}

export default M11Step021TrialInterventionPart1;
export { M11Step021TrialInterventionPart1HelperText, M11Step021TrialInterventionPart1ValidationCheck };